
export default function Loader({ text = "Please wait..." }: { text?: string }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div className="bg-white px-6 py-5 rounded-xl shadow-lg flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-700">{text}</p>
      </div>
    </div>
  );
}
